export const environment = {
  base_url: 'https://mindbaseadminapi.appgrowthcompany.com/',
  image_url: 'https://mindbaseadminapi.appgrowthcompany.com/admin/media/uploadFile',
  socket_url: 'mindbasesocketapi.appgrowthcompany.com/',
  rememberMeKey: 'MB_RM_SK_D',
  storageKey: 'MB_A_SK_D',
  googleKey: 'AIzaSyDIZwbQqi5J9a7DAHuTGs8_zbKK6by891s',
  firebaseConfig: {
    apiKey: 'AIzaSyA74yJXmt34C2E_yyTQOgwMlH12O90rS9w',
    authDomain: 'prepbase-76b91.firebaseapp.com',
    projectId: 'prepbase-76b91',
    storageBucket: 'prepbase-76b91.firebasestorage.app',
    messagingSenderId: '181364161362',
    appId: '1:181364161362:web:67ce0863d646f91c81d88b',
    measurementId: 'G-D9P45VNQLT',
    vapidKey: 'BAeAjs2pkYIY9TwQfEw6394Sf1-drYjtBpqmXfxj38au1sEkS-TWxUQ35lgn2AI5XlMBshcUjY6snJIAyR1mnCw'
  },
  stripePublicKey: 'pk_test_51Qpp54E9dCHbiXJV6Okor1RpLgwCLKDTvIIOq7SFdVfU7Q1UyuoVFactBrmrdqCe1ZYcx4gh53KIZjJDh4522teq00jWleYgRa'
  // stripePublicKey: 'pk_test_51PAmx5SJeoR7HKHV49ccTs0DjSSq80TM02hL3cod6XXDUIUMVoQtAR5cDLlhUnPNMZGqHhrZSTegrsq5sM9o2D5F00TIUAKLt1'

};

